// This sentry import should always be the first one.
import './sentry-config.ts'
//
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { store } from '@/app-storage/store.ts'
import { router } from './routing/routes.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AppAlertProvider } from '@/app/AppAlertProvider.tsx'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { keycloakAuthService } from './auth/keycloak'

const FIVE_MINUTES = 1000 * 60 * 5 // in milliseconds
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      staleTime: FIVE_MINUTES,
    },
  },
})

const PersistedStore = persistStore(store)

async function bootstrap() {
  await keycloakAuthService().initializeAuth()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={PersistedStore}>
          <QueryClientProvider client={queryClient}>
            <AppAlertProvider>
              <RouterProvider router={router} />
            </AppAlertProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  )
}

bootstrap()
